import React, { useState, useEffect, useMemo } from "react";
import "../../styles/styles.scss";
import "./styles.scss";
import { Table, NavDropdown, Col, Row, Container } from "react-bootstrap";
import {
  ActionButton,
  ScreenNav,
  SearchInput,
  TextInput,
} from "../../components";
import CheckRadio from "../../components/CheckRadio";
import DatePicker from "../../components/DatePicker";
import { EditIcon } from "../../resources/icons";
import DeleteIcon from "../../resources/icons/DeleteIcon";
import Dropdown from "react-bootstrap/Dropdown";
import { URL, API_VERSION_MB } from "../../config/constants";


const ZoneandRates = (props) => {
  const [accdata, setAccData] = useState([]);
  const [selectCompany, setSelectCompany] = useState("Seleccione Usuario");
  const [rows, setRows] = useState([]);
  const [inputValues, setInputValues] = useState([]);
  const [selectDate, setSelectedDate] = useState(null);

  // 🔹 Leer token y nombre empresa
  const { token, companyName } = useMemo(() => {
    const value = JSON.parse(localStorage.getItem("persist:root"));
    const valuetoken = JSON.parse(value.auth);
    return {
      token: valuetoken.userData.token,
      companyName: props.history.location.state.companyName,
    };
  }, [props.history.location.state.companyName]);

  // 🔹 Manejo de inputs dinámicos
  const handleChange = (i, field, value) => {
    setInputValues((prev) => {
      const updated = [...prev];
      updated[i] = {
        ...updated[i],
        id: i,
        [field]: value,
      };
      return updated;
    });
  };

  const handleChangeDate = (date) => setSelectedDate(date);

  const addFilas = (num) => {
    const newRows = Array.from({ length: num }, (_, i) => ({
      id: i + 1,
    }));
    setRows(newRows);
  };

  const handleDelete = (index) => {
    setRows((prev) => prev.filter((_, i) => i !== index));
    setInputValues((prev) => prev.filter((_, i) => i !== index));
  };

  // 🔹 Fetchs originales
  useEffect(() => {
    const headers = new Headers({
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    });

    const config = { method: "GET", headers };

    fetch(`${URL}${API_VERSION_MB}/api/account`, config)
      .then((response) => response.json())
      .then((accdata) => setAccData(accdata.data))
      .catch((err) => console.error("Error fetching accounts:", err));

    fetch(`${URL}${API_VERSION_MB}/api/enabled-places`, config)
      .then((response) => response.json())
      .then((data) => console.log(data))
      .catch((err) => console.error("Error fetching places:", err));
  }, [token]);

  return (
    <Container fluid>
      <Row style={{ justifyContent: "flex-start", margin: "5rem 0" }}>
        <Col xs={12} sm={8}>
          <h3 style={{ textTransform: "uppercase" }}>
            Administrar Zonas y Tarifas - {companyName}
          </h3>
        </Col>
      </Row>

      <Row style={{ justifyContent: "center", margin: "1rem" }}>
        <Col xs={12} md={6}>
          <Row>
            <TextInput
              label="Ingrese nombre del tarifario actual:"
              controlId="name"
              name="name"
              inputType="text"
              placeholder="Nombre del tarifario"
            />
          </Row>

          <Row>
            <Dropdown>
              <Dropdown.Toggle className="clonedrop" id="dropdown-basic">
                {selectCompany}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {accdata.map((option) => (
                  <Dropdown.Item
                    key={option.id}
                    onClick={() => setSelectCompany(option.companyName)}
                  >
                    {option.companyName}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
              <ActionButton type="submit">Clonar</ActionButton>
            </Dropdown>
          </Row>

          <Row>
            <NavDropdown
              className="border border-dark rounded-1 mt-4 mb-3"
              title={`Cantidad de Zonas: ${rows.length}`}
              id="nav-dropdown"
            >
              {[1, 2, 3, 4, 5, 6, 7].map((n) => (
                <NavDropdown.Item key={n} onClick={() => addFilas(n)}>
                  {n}
                </NavDropdown.Item>
              ))}
            </NavDropdown>
          </Row>
        </Col>

        <Col xs={12} md={6}>
          <Row>
            <NavDropdown
              className="border border-dark rounded-1 mt-4 mb-3"
              title={"Tarifas"}
              id="tarifas-dropdown"
            >
              {[
                "Tarifas",
                "Seguros",
                "Envios a domicilio",
                "Retiro a domicilio",
                "Todos",
                "Otros importes",
              ].map((item) => (
                <NavDropdown.Item key={item}>{item}</NavDropdown.Item>
              ))}
            </NavDropdown>
            <CheckRadio inline disabled type="radio" label="Monto fijo" />
            <CheckRadio inline type="radio" label="Porcentaje" />
          </Row>

          <Row>
            <TextInput
              label="Actualizar tarifas: "
              name="update"
              inputType="text"
              placeholder="%"
              disabled
            />
            <ActionButton type="submit" disabled>
              Actualizar
            </ActionButton>
          </Row>

          <Row>
            <DatePicker
              label="Vigencia Desde:"
              className="picker form-control"
              selected={selectDate}
              onChange={handleChangeDate}
              dateFormat="dd/MM/yyyy"
              readOnly
            />
          </Row>
        </Col>
      </Row>

      {/* TABLA */}
      <Container fluid>
        <Row style={{ justifyContent: "center", overflowX: "auto" }}>
          <Table bordered hover>
            <thead>
              <tr className="trclass">
                <th>Zona</th>
                <th>Nombre</th>
                <th>Valor Final(KG)</th>
                <th>Incremento Peso(KG)</th>
                <th>Valor Inicial Tarifa($)</th>
                <th>Incremento Tarifa Flete</th>
                <th>SEGURO</th>
                <th>Envío Domicilio</th>
                <th>Retiro Domicilio</th>
                <th>Otros Importes</th>
                <th>Incremento Tarifa Adicionales</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>
                    <TextInput
                      value={inputValues[i]?.name || ""}
                      onChange={(e) =>
                        handleChange(i, "name", e.target.value)
                      }
                    />
                  </td>
                  {[
                    "finalKilogramValue",
                    "increasedWeight",
                    "startingTariffPrice",
                    "tariffPriceIncrease",
                    "insurance",
                    "homeDelivery",
                    "homeWithdrawal",
                    "others",
                    "additionalPriceIncrease",
                  ].map((field) => (
                    <td key={field}>
                      <TextInput
                        inputType="number"
                        value={inputValues[i]?.[field] || ""}
                        onChange={(e) =>
                          handleChange(i, field, e.target.value)
                        }
                      />
                    </td>
                  ))}
                  <td className="text-left text-warning">
                    <EditIcon type="secondaryIcon" width="23" height="20" />
                    <DeleteIcon
                      onClick={() => handleDelete(i)}
                      type="secondaryIcon"
                      width="23"
                      height="20"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Row>
      </Container>

      {/* BOTONES */}
      <Row style={{ width: "100%", justifyContent: "flex-end" }}>
        <Col xs={11} sm={6} md={3} className="p-0" style={{ margin: "2rem" }}>
          <ActionButton
            type="submit"
            width="90"
            onClick={() => {
              const name = document.getElementById("name").value;
              props.history.push({
                pathname: "/zones-and-rates/location-by-zone",
                state: {
                  companyName,
                  rows: rows.length,
                  inputValues,
                  validSince: selectDate,
                },
              });
            }}
          >
            Aceptar
          </ActionButton>
          <ActionButton
            secondary
            width="90"
            onClick={() =>
              props.history.push({
                pathname: "/account-modification",
              })
            }
          >
            Volver
          </ActionButton>
        </Col>
      </Row>
    </Container>
  );
};

export default ZoneandRates;
